import React from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "@/contexts/AuthContext";
import { LocaleProvider } from "@/contexts/LocaleContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { MaintenanceProvider } from "@/contexts/MaintenanceContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicMaintenanceGate from "@/components/PublicMaintenanceGate";

import PublicHome from "@/pages/public/Home";
import About from "@/pages/public/About";
import MenuPage from "@/pages/public/Menu";
import ContactPage from "@/pages/public/Contact";
import Events from "@/pages/public/Events";
import EventDetail from "@/pages/public/EventDetail";
import BookingPage from "@/pages/public/Booking";
import BookingConfirm from "@/pages/public/BookingConfirm";
import LegalPage from "@/pages/public/LegalPage";

import AdminLogin from "@/pages/AdminLogin";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminRecover from "@/pages/AdminRecover";
import AdminRecoverConsume from "@/pages/AdminRecoverConsume";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProfile from "@/pages/AdminProfile";
import AdminUsers from "@/pages/AdminUsers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminPages from "@/pages/admin/AdminPages";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminContact from "@/pages/admin/AdminContact";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminTables from "@/pages/admin/AdminTables";
import AdminBookingSettings from "@/pages/admin/AdminBookingSettings";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <LocaleProvider>
            <SettingsProvider>
              <AuthProvider>
                <MaintenanceProvider>
                  <PublicMaintenanceGate>
                    <Routes>
                  {/* Public site */}
                  <Route path="/" element={<PublicHome />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/menu" element={<MenuPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:slug" element={<EventDetail />} />
                  <Route path="/booking" element={<BookingPage />} />
                  <Route path="/booking/confirm" element={<BookingConfirm />} />
                  <Route path="/privacy" element={<LegalPage slug="privacy-policy" fallbackTitle="Politika privatnosti" />} />
                  <Route path="/terms" element={<LegalPage slug="terms" fallbackTitle="Uvjeti korištenja" />} />
                  <Route path="/cookies" element={<LegalPage slug="cookies" fallbackTitle="Politika kolačića" />} />
                  <Route path="/imprint" element={<LegalPage slug="imprint" fallbackTitle="Impresum" />} />

                  {/* Auth */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
                  <Route path="/admin/reset-password" element={<AdminResetPassword />} />
                  <Route path="/admin/recover" element={<AdminRecover />} />
                  <Route path="/admin/recover/consume" element={<AdminRecoverConsume />} />

                  {/* Admin (protected) */}
                  <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                  <Route path="/admin/profile" element={<ProtectedRoute><AdminProfile /></ProtectedRoute>} />
                  <Route path="/admin/users" element={<ProtectedRoute requireSuperadmin><AdminUsers /></ProtectedRoute>} />
                  <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
                  <Route path="/admin/pages" element={<ProtectedRoute><AdminPages /></ProtectedRoute>} />
                  <Route path="/admin/menu" element={<ProtectedRoute><AdminMenu /></ProtectedRoute>} />
                  <Route path="/admin/media" element={<ProtectedRoute><AdminMedia /></ProtectedRoute>} />
                  <Route path="/admin/contact" element={<ProtectedRoute><AdminContact /></ProtectedRoute>} />
                  <Route path="/admin/events" element={<ProtectedRoute><AdminEvents /></ProtectedRoute>} />
                  <Route path="/admin/bookings" element={<ProtectedRoute><AdminBookings /></ProtectedRoute>} />
                  <Route path="/admin/tables" element={<ProtectedRoute><AdminTables /></ProtectedRoute>} />
                  <Route path="/admin/booking-settings" element={<ProtectedRoute><AdminBookingSettings /></ProtectedRoute>} />

                  <Route path="*" element={<NotFound />} />
                </Routes>
                  </PublicMaintenanceGate>
                </MaintenanceProvider>
                <Toaster
                  theme="dark"
                  position="top-right"
                  toastOptions={{
                    style: {
                      background: "#111",
                      color: "#f5ecd1",
                      border: "1px solid #3a2f12",
                    },
                  }}
                />
              </AuthProvider>
            </SettingsProvider>
          </LocaleProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
